export const FETCH_PAGE_DATA_IN_PROGRESS = 'FETCH_PAGE_DATA_IN_PROGRESS'
export const FETCH_PAGE_DATA_SUCCESS = 'FETCH_PAGE_DATA_SUCCESS'
export const FETCH_PAGE_DATA_FAILED = 'FETCH_PAGE_DATA_FAILED'
export const OPEN_SEARCH_BOX = 'OPEN_SEARCH_BOX'

